import React from "react";
import { Modal, Tabs, Row, Col } from "antd-v5";
import moment from "moment";
import { CourseLessonOrderEnt, EqEntityEventUserGroup, StudentUnpaidOrdersInfoDto } from "../../shared/general/IStudentUnpaidOrders";
import { EqIconCalendar, EqIconPrice } from "../../custom/eqIcon/EqIcons";
import EqButton from "../../custom/eqButton/EqButton";
import { useTranslation } from "react-i18next";
import EtTag from "../../../eqComponents/eqCustom/EtTag/EtTag";
import { CourseOrderType } from "../../shared/enums";
import "./UnPaidOrdersModalStudent.scss"
import { useNavigate } from "react-router-dom";
interface UnPaidOrdersModalStudentProps {
    isModalVisible: boolean;
    handleCancel: () => void;
    checkClosable: () => boolean;
    unpaidOrders?: StudentUnpaidOrdersInfoDto;
    GetCourseOrderCheckoutSession: (id: string) => void;
    GetCourseLessonOrderCheckoutSession: (id: string) => void;
    CreateTrainingLessonOrderCheckoutSession: (event: any) => void;
}

const UnPaidOrdersModalStudent: React.FC<UnPaidOrdersModalStudentProps> = ({
    isModalVisible,
    handleCancel,
    unpaidOrders,
    GetCourseOrderCheckoutSession,
    GetCourseLessonOrderCheckoutSession,
    CreateTrainingLessonOrderCheckoutSession,
    checkClosable,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleModalCancel = (e: React.MouseEvent<HTMLButtonElement>) => {
        
        
        // If user clicked on mask (outside the modal content)
        const target = e.target as HTMLElement;
        if (target.classList.contains("ant-modal") || target.classList.contains("ant-modal-wrap")) {
           let closable=checkClosable();
            if(closable){
            handleCancel(); // Close modal normally

            }else{

                navigate("/login"); // Redirect to login screen
            }
        } else {
            handleCancel(); // Close modal normally
        }
    };
    return (
        <Modal
            width={1000}
            title={t('unPaidOrders')}
            className="unpaid-Orders-modal-student"
            open={isModalVisible}
            onCancel={handleModalCancel}
            footer={null}
            // closable={checkClosable()}
            closable={true}
            maskClosable={true}
        >
            <Tabs defaultActiveKey="1">
                {/* Course Orders Tab */}
                {((unpaidOrders?.unPaidCourseOrders && unpaidOrders.unPaidCourseOrders.length > 0) ||
                    (unpaidOrders?.unPaidCourseLessonOrders && unpaidOrders.unPaidCourseLessonOrders.length > 0)) && (
                    <Tabs.TabPane tab={t('courseOrders')} key="1">
                        {/* Render Course Orders */}
                        {unpaidOrders.unPaidCourseOrders?.map((item, index) => (
                            <div className="eq-activity-row" key={index}>
                                <Row className="eq-status-row-border">
                                    <Col className="content-col">
                                        <Row>
                                            <Col>
                                                <div className="date-icon">
                                                    <EqIconCalendar eqWidth={34} eqHeight={34} eqClass="eq-cal-icon" eqFill="#083b49" />
                                                    <div className="day">{moment(item.course?.startDate).format('DD')}</div>
                                                    <div className="month">{moment(item.course?.startDate).format('MMM')}</div>
                                                </div>
                                            </Col>
                                            <Col className="header-details">
                                                <Row>
                                                    <Col></Col>
                                                    <Col>
                                                        <span className="time">{moment(item.course?.startDate).format('hh:mm A')}</span>
                                                    </Col>
                                                    <Col className="price">
                                                        <EqIconPrice eqWidth="15" eqHeight="13" eqFill="#b5b5b5" />{' '}
                                                        {item.customPrice || item.course?.coursePrice}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className="eq-f-th">{item.course?.title}</Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col className="action-col">
                                        <EqButton onClick={() => GetCourseOrderCheckoutSession(item.id)}>{t('payNow')}</EqButton>
                                    </Col>
                                </Row>
                            </div>
                        ))}

                        {/* Render Course Lesson Orders */}
                        {unpaidOrders.unPaidCourseLessonOrders?.map((item, index) => (
                            <div className="eq-activity-row" key={index}>
                                <Row className="eq-status-row-border">
                                    <Col className="content-col">
                                        <Row>
                                            <Col>
                                                <div className="date-icon">
                                                    <EqIconCalendar eqWidth={34} eqHeight={34} eqClass="eq-cal-icon" eqFill="#083b49" />
                                                    <div className="day">{moment(item.courseLesson?.startTime).format('DD')}</div>
                                                    <div className="month">{moment(item.courseLesson?.startTime).format('MMM')}</div>
                                                </div>
                                            </Col>
                                            <Col className="header-details">
                                                <Row>
                                                    <Col></Col>
                                                    <Col>
                                                        <span className="time">{moment(item.courseLesson?.startTime).format('hh:mm A')}</span>
                                                    </Col>
                                                    <Col>
                                                    <EtTag>
                                                                {CourseOrderType[item?.orderType]}
                                                            </EtTag>
                                                    </Col>
                                                    <Col className="price">
                                                        <EqIconPrice eqWidth="15" eqHeight="13" eqFill="#b5b5b5" />{' '}
                                                        {item.customPrice || item.courseLesson?.price}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className="eq-f-th">{item.courseLesson?.course?.title}</Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col className="action-col">
                                        <EqButton onClick={() => GetCourseLessonOrderCheckoutSession(item.id)}>{t('payNow')}</EqButton>
                                    </Col>
                                </Row>
                            </div>
                        ))}
                    </Tabs.TabPane>
                )}

                {/* Training Orders Tab */}
                {unpaidOrders?.unPaidTrainingOrders && unpaidOrders.unPaidTrainingOrders.length > 0 && (
                    <Tabs.TabPane tab={t('trainingOrders')} key="2">
                        {unpaidOrders.unPaidTrainingOrders.map((item, index) => (
                            <div className="eq-activity-row" key={index}>
                                <Row className="eq-status-row-border">
                                    <Col className="content-col">
                                        <Row>
                                            <Col>
                                                <div className="date-icon">
                                                    <EqIconCalendar eqWidth={34} eqHeight={34} eqClass="eq-cal-icon" eqFill="#083b49" />
                                                    <div className="day">{moment(item.event?.startDate).format('DD')}</div>
                                                    <div className="month">{moment(item.event?.startDate).format('MMM')}</div>
                                                </div>
                                            </Col>
                                            <Col className="header-details">
                                                <Row>
                                                    <Col></Col>
                                                    <Col>
                                                        <span className="time">{moment(item.event?.startTime).format('hh:mm A')}</span>
                                                    </Col>
                                                    <Col className="price">
                                                        <EqIconPrice eqWidth="15" eqHeight="13" eqFill="#b5b5b5" /> {item.event?.price}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className="title">{item.event?.title}</Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col className="action-col">
                                        <EqButton onClick={() => CreateTrainingLessonOrderCheckoutSession(item.event)}>
                                            {t('payNow')}
                                        </EqButton>
                                    </Col>
                                </Row>
                            </div>
                        ))}
                    </Tabs.TabPane>
                )}
            </Tabs>
        </Modal>
    );
};

export default UnPaidOrdersModalStudent;